module.exports = __webpack_public_path__ + "static/media/Pending_approval.2a4d1969.svg";